import React, {Component} from 'react';
import {Redirect} from "react-router-dom";


class LastChanceButtonLeft extends Component {

    state = {
        redirect : null,

    }



    componentDidMount = () => {

    }



  render() { 

    return (      


            <div className="last_chance_button_htl">
                <div className="last_chance_button_right_htl">
                <img className="last_chance_button_img" src={"/images/site/hotelsAll.png"} alt=""/> 
                </div>
                <div className="last_chance_button_left_htl">
                    <div className="last_chance_main_title directionRtl">
                        לאן לנסוע ברגע האחרון?
                    </div>
                    <div className="last_chance_main_desc">
                    כאן תוכלו למצוא נופש לעוד שלושה שבועות עד עוד שבוע בכל הארץ
למעט אילת
                    </div>

                    <div className="last_chance_inner_button_ok"
                            onClick={() => this.props.setCurrentHotelsForOrderLastChance(2)}>
                            <div className="title">לכל היעדים</div>
                    </div>
                </div>
            </div>      
    )
  }
}

export default LastChanceButtonLeft;
